import * as React from 'react';
import { NavLink } from "react-router-dom";
import clsx from 'clsx';
import { useDispatch } from "react-redux";
import customStyles from "../../../../assets/styles/customStyles";
import actions from "../../../Dashboard/redux/actions";
import { useSelector } from "react-redux";
import { handleHeight } from "../../../../helpers/utilities";

export const QuickLinks = (props) => {
    const { quickLinksToggle } = useSelector(state => state.commonReducer);
    const { menus, factBox, component } = props;
    const dispatch = useDispatch();
    const classes = customStyles();

    const setToggle = () => {
        dispatch({
            type: actions.QUICKLINKS_START,
            menus: menus,
            factBox: factBox,
            toggle: !quickLinksToggle,
            component: component
        });
        setTimeout(() => {
            handleHeight(classes);
        }, 200);
    }
    return (
        <NavLink to={'#'} onClick={() => setToggle()} className={clsx(classes.quickBtn, classes.bold, { [classes.none]: quickLinksToggle })}>
            Quick Links
        </NavLink>
    );
}
